import { useEffect, useState } from 'react';
import { api } from '../lib/api.js';
import { Card, EmptyState, ErrorNote, PageTitle, Spinner } from '../components/ui.jsx';

export default function Audit() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  function load() {
    setError(null);
    api
      .get('/api/admin/audit?perPage=100')
      .then(setData)
      .catch((err) => setError(err.message));
  }

  useEffect(load, []);

  return (
    <>
      <PageTitle
        title="Audit log"
        description="Every change made in the admin, with who made it and what changed. Kept so any change to the live site is explainable after the fact."
      />

      <ErrorNote error={error} onRetry={load} />

      {!data ? (
        <Spinner />
      ) : data.items.length === 0 ? (
        <EmptyState title="Nothing recorded yet" />
      ) : (
        <Card>
          <table className="w-full text-left text-sm">
            <thead className="border-b-3 border-ink">
              <tr>
                <th className="p-4 text-xs uppercase tracking-widest">When</th>
                <th className="p-4 text-xs uppercase tracking-widest">Who</th>
                <th className="p-4 text-xs uppercase tracking-widest">Action</th>
                <th className="p-4 text-xs uppercase tracking-widest">Entity</th>
                <th className="p-4 text-xs uppercase tracking-widest">Changed</th>
              </tr>
            </thead>
            <tbody>
              {data.items.map((entry) => {
                const changed = entry.after ? Object.keys(entry.after) : [];
                return (
                  <tr key={entry.id} className="border-b border-line last:border-0">
                    <td className="p-4 text-xs text-muted">
                      {new Date(entry.createdAt).toLocaleString()}
                    </td>
                    <td className="p-4 text-xs">{entry.user?.name ?? 'system'}</td>
                    <td className="p-4 font-mono text-xs font-semibold">{entry.action}</td>
                    <td className="p-4 text-xs text-muted">{entry.entity}</td>
                    <td className="p-4 text-xs text-muted">
                      {changed.length ? changed.slice(0, 5).join(', ') : '—'}
                      {changed.length > 5 && ` +${changed.length - 5}`}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </Card>
      )}
    </>
  );
}
